/* eslint-disable sonarjs/cognitive-complexity */
'use client';

import TruckGroupServices from '@/features/booking/components/truck/truck-service/truck-group-services';
import TruckServiceVehicle from '@/features/booking/components/truck/truck-service/truck-service-vehicle';

export default function TruckService() {
  return (
    <>
      <TruckGroupServices />
      <TruckServiceVehicle />
    </>
  );
}
